import React from "react";
import { Helmet } from "react-helmet-async";
import HomeApplicationForm from "../components/HomeApplicationForm/HomeApplicationForm";
import CampaignsSection from "../components/Campaigns/CampaignsSection";
import FiberInternet from "../components/FiberInternet/FiberInternet";

function HomePage() {
  return (
    <>
      <Helmet>
        <title>Fiber İnternet Kampanyaları | Fiber İnternetim</title>
        <meta
          name="description"
          content="Uygun fiyatlı fiber internet kampanyaları, altyapı sorgulama ve hızlı başvuru."
        />
        <link rel="canonical" href="https://www.fiberinternetim.com.tr/" />
      </Helmet>

      <HomeApplicationForm />
      <CampaignsSection />
      <FiberInternet />
    </>
  );
}

export default HomePage;
